export default __webpack_public_path__ + "static/media/multiModal.55cb6c53.png";